// extracted by mini-css-extract-plugin
module.exports = {"loading":"Select_loading__9982E","ellipsis":"Select_ellipsis__2LQkl","container":"Select_container__27YJY","main":"Select_main__2ShDZ"};